import { render, staticRenderFns } from "./batchManage.vue?vue&type=template&id=46ae083e&scoped=true&"
import script from "./batchManage.vue?vue&type=script&lang=js&"
export * from "./batchManage.vue?vue&type=script&lang=js&"
import style0 from "./batchManage.vue?vue&type=style&index=0&id=46ae083e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae083e",
  null
  
)

export default component.exports